import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';

const ENTITY = 'ClientPO';

export function useManualReceivables() {
  const qc = useQueryClient();

  const { data: manualReceivables = [], isLoading, refetch } = useQuery({
    queryKey: ['manual-receivables'],
    queryFn: async () => {
      const list = await base44.entities[ENTITY].list('-created_date');
      return list.filter(item => item._isManualReceivable);
    },
    staleTime: 5000,
  });

  const createMut = useMutation({
    mutationFn: (payload) => {
      return base44.entities[ENTITY].create({
        ...payload,
        _isManualReceivable: true
      });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['manual-receivables'] }),
  });

  const updateMut = useMutation({
    mutationFn: ({ id, ...payload }) => base44.entities[ENTITY].update(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['manual-receivables'] }),
  });

  const deleteMut = useMutation({
    mutationFn: (id) => base44.entities[ENTITY].hardDelete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['manual-receivables'] }),
  });

  return {
    manualReceivables,
    isLoading,
    refetch,
    createManualReceivable: createMut.mutateAsync,
    updateManualReceivable: (id, data) => updateMut.mutateAsync({ id, ...data }),
    deleteManualReceivable: deleteMut.mutateAsync,
  };
}
